// アンカーリンク
// $(function () {
//     $('a[href^="#"]').click(function () {
//         let speed = 800;
//         let href = $(this).attr("href");
//         let target = $(href == "#" || href == "" ? 'html' : href);
//         let position = target.offset().top;
//         $("html, body").animate({
//             scrollTop: position
//         }, speed, "swing");
//         return false;
//     });
// });


// ハンバーガーメニュー
document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.header_burger');
    const headNav = document.querySelector('.burger_menu');
    const header = document.querySelector('.l_header');
    const body = document.querySelector('body');

    hamburger.addEventListener('click', () => {
        if (hamburger.classList.contains("is-active")) {
            hamburger.classList.remove('is-active');
            // hamburger.querySelector('.c-hamburger__text').textContent = 'MENU';
            headNav.classList.remove('is-active')
            if (header.classList.contains("is-active")) {
                header.classList.remove('is-active')
            } else {}
        } else {
            hamburger.classList.add('is-active');
            // hamburger.querySelector('.c-hamburger__text').textContent = 'CLOSE';
            headNav.classList.add('is-active')
            if (header.classList.contains("is-active")) {} else {
                header.classList.add('is-active')
            }
        }
        body.classList.toggle('is-fixed');
    });


});

// スクロールヘッダー
$(function () {
    $(window).on('scroll', function () {
        if (300 < $(this).scrollTop()) {
            $('.header').addClass('active');
        } else {
            $('.header').removeClass('active');
        }
    });
});


